import { FC } from 'react';
import { components, GroupBase, MenuListProps } from 'react-select';

type Props = MenuListProps<unknown, boolean, GroupBase<unknown>>;

export const MenuListWithoutSelectAll: FC<Props> = (props) => {
  return <components.MenuList {...props} />;
};
